import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { CommunityBankService, GeneralService } from '@app/core/http';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { finalize } from 'rxjs/operators';
import { BeautifulEnumPipe } from 'ngx-venus';
import { ActivatedRoute, Router } from '@angular/router';

@UntilDestroy()
@Component({
  selector: 'app-select-amount',
  templateUrl: './select-amount.component.html',
  styleUrls: ['./select-amount.component.css'],
  providers: [BeautifulEnumPipe],
})
export class SelectAmountComponent implements OnInit, OnDestroy {
  constructor(
    private generalService: GeneralService,
    private communityBankService: CommunityBankService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  isLoading = true;
  selectedAmount = null;
  amounts = null;
  swiftCode = null;
  bank = {
    swiftCode: '',
    bankName: '',
  };
  cancelRedirectUrl = null;

  isBankChangeable = JSON.parse(localStorage.getItem('transaction'))[
    'defaultPaymentMethod'
  ]
    ? false
    : true;

  ngOnInit() {
    this.swiftCode = this.route.snapshot.paramMap.get('swiftCode');
    this.cancelRedirectUrl = localStorage.getItem('cancelRedirectUrl') || null;
    this.getBank();
    this.getAmounts();
  }

  getBank() {
    this.communityBankService
      .getBanks()
      .pipe(finalize(() => (this.isLoading = false)))
      .pipe(untilDestroyed(this))
      .subscribe((banks) => {
        this.bank = banks.find(
          (item) => item.swiftCode === this.swiftCode.toUpperCase()
        );
      });
  }

  getAmounts() {
    this.isLoading = true;
    const params = {
      maxAmount: JSON.parse(localStorage.getItem('transaction'))['maxAmount'],
      minAmount: JSON.parse(localStorage.getItem('transaction'))['minAmount'],
      swiftCode: this.swiftCode.toUpperCase(),
    };

    this.communityBankService
      .getAmounts(params)
      .pipe(finalize(() => (this.isLoading = false)))
      .pipe(untilDestroyed(this))
      .subscribe((amounts) => {
        this.amounts = amounts;
      });
  }

  onSubmit() {
    this.isLoading = true;
    const params = {
      defaultPaymentMethod:
        JSON.parse(localStorage.getItem('transaction'))[
          'defaultPaymentMethod'
        ] || 'COMMUNITY_BANK',
      amount: this.selectedAmount.amount,
      currency: this.selectedAmount.currency,
    };

    this.generalService
      .initializeTransaction(params)
      .pipe(finalize(() => (this.isLoading = false)))
      .pipe(untilDestroyed(this))
      .subscribe((response) => {
        localStorage.setItem(
          'communityBank',
          JSON.stringify({
            bankCode: this.bank.swiftCode,
            activeAmountId: +this.selectedAmount.activeAmountId,
          })
        );
        if (response && response.redirectUrl) {
          window.location.href = response.redirectUrl;
        }
      });
  }

  backToMerchant() {
    localStorage.clear();
    window.location.href = this.cancelRedirectUrl;
  }

  change() {
    this.router.navigate([`/community-banks`]);
  }

  ngOnDestroy() {}
}
